<template>
  <b-card no-body class="card-developer-meetup">
    <b-card-title>
      <div class="skeleton-box" style="width: 100%; height: 120px;" />
    </b-card-title>
    <b-card-body class="p-1">
      <div class="d-flex mb-1">
        <div class="skeleton-box mr-1" v-for="i in 2" :key="i" style="width: 50px; height: 20px;" />
      </div>
      <!-- header -->
      <div class="meetup-header d-flex align-items-center" style="height:7.7vh;">
        <div class="meetup-day">
          <h6 class="mb-0 text-uppercase">
            <div class="skeleton-box" style="width: 40px;" />
          </h6>
          <h3 class="mb-0">
            <div class="skeleton-box" style="width: 30px;" />
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title class="mb-25">
            <div class="skeleton-box" style="width: 70px;" />
            <div class="skeleton-box" style="width: 85px;" />
          </b-card-title>
        </div>
      </div>
      <!-- end header -->
      <!-- speaker -->
      <b-media no-body>
        <b-media-aside class="mr-1">
          <div class="skeleton-box" style="width: 34px; height: 34px;" />
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            <div class="skeleton-box" style="width: 60px;" />
          </h6>
          <small>
            <div class="skeleton-box" style="width: 80px;" />
          </small>
        </b-media-body>
      </b-media>
      <!-- end speaker -->
      <!-- date -->
      <b-media no-body>
        <b-media-aside class="mr-1">
          <div class="skeleton-box" style="width: 34px; height: 34px;" />
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            <div class="skeleton-box" style="width: 60px;" />
          </h6>
          <small>
            <div class="skeleton-box" style="width: 80px;" />
          </small>
        </b-media-body>
      </b-media>
      <!-- end date -->
      <!-- address -->
      <b-media no-body style="height:7.5vh">
        <b-media-aside class="mr-1">
          <div class="skeleton-box" style="width: 34px; height: 34px;" />
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            <div class="skeleton-box" style="width: 60px;" />
          </h6>
        </b-media-body>
      </b-media>
      <!-- end address -->
    </b-card-body>
  </b-card>
</template>

<script>
  import {
    BCard,
    BCardText,
    BCardTitle,
    BCardBody,
    BBadge,
    BImg,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BPagination,
  } from 'bootstrap-vue'

  export default {
    components: {
      BCard,
      BCardText,
      BCardTitle,
      BBadge,
      BCardBody,

      BImg,
      BMedia,
      BMediaAside,
      BAvatar,
      BMediaBody,
      BPagination,
    },
  }
</script>

<style lang="scss" scoped>
.skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #DDDBDD;
  border-radius: 8px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg,
        rgba(#fff, 0) 0,
        rgba(#fff, 0.2) 20%,
        rgba(#fff, 0.5) 60%,
        rgba(#fff, 0));
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>